import { createStore } from "vuex";
import lab from "./modules/lab";
const store = createStore({
  modules: {
    lab,
  },
});

export default store;

// 使用示例
// <template>
//   <view class="content">
//     <image class="logo" src="/static/logo.png"></image>
//     <view class="text-area">
//       <text class="title">{{ title }}</text>
//       <button @click="setToken">Login</button>
//     </view>
//   </view>
// </template>

// <script setup>
// import { ref } from 'vue'
// import { useStore } from 'vuex'
// const title = ref('Hello')
// const store = useStore()
// const setToken = () => {
//   store.commit('SET_TOKEN', 'token')
//   title.value = store.getters.token
// }
// </script>
